import { Field as BaseField } from "@base-ui-components/react/field";
import words from "lodash/words";
import capitalize from "lodash/capitalize";
import {
  adornmentClasses,
  controlClasses,
  errorClasses,
  FieldVariantProps,
  fieldWrapperClasses,
  helpTextClasses,
  labelClasses,
  rootClasses,
} from "./Field.style";
import { InputHTMLAttributes, ReactElement } from "react";

export type FieldProps = BaseField.Root.Props &
  FieldVariantProps & {
    helpText?: string;
    label?: string;
    error?: string;
    inputProps?: BaseField.Control.Props;
    startAdornment?: ReactElement<any>;
    endAdornment?: ReactElement<any>;
    type?: InputHTMLAttributes<HTMLInputElement>["type"];
    required?: InputHTMLAttributes<HTMLInputElement>["required"];
    placeholder?: InputHTMLAttributes<HTMLInputElement>["placeholder"];
    className?: InputHTMLAttributes<HTMLInputElement>["className"];
    wrapperclassName?: InputHTMLAttributes<HTMLDivElement>["className"];
    value?: InputHTMLAttributes<HTMLInputElement>["value"];
  };
const Field = (props: FieldProps) => {
  const {
    helpText,
    label,
    name,
    type,
    required,
    placeholder,
    startAdornment,
    endAdornment,
    error,
    className,
    colSpan,
    value,
    invalid,
    inputProps,
    wrapperclassName,
    ...rest
  } = props;

  const hasStartAdornment = startAdornment !== undefined;
  const hasEndAdornment = endAdornment !== undefined;
  const isFileType = props.type === "file";

  const capitalizeName = capitalize(words(name).join(" "));

  return (
    <BaseField.Root
      invalid={Boolean(error) || invalid}
      name={name}
      {...rest}
      className={rootClasses({ colSpan, className: className })}
      validationMode={isFileType ? "onBlur" : "onChange"}
    >
      {(label || capitalizeName) && (
        <BaseField.Label className={labelClasses({ required })}>
          {label || capitalizeName}
        </BaseField.Label>
      )}

      <div className={fieldWrapperClasses({ class: wrapperclassName })}>
        {startAdornment && (
          <div
            className={adornmentClasses({
              hasStartAdornment,
              hasEndAdornment,
            })}
          >
            {startAdornment}
          </div>
        )}
        <BaseField.Control
          required={required}
          type={type || "text"}
          value={value}
          placeholder={placeholder || `Please enter your ${capitalizeName}`}
          {...inputProps}
          className={controlClasses({
            hasStartAdornment,
            hasEndAdornment,
            isFile: isFileType,
            class:
              typeof inputProps?.className === "string"
                ? inputProps?.className
                : "",
          })}
        />
        {endAdornment && (
          <div
            className={adornmentClasses({
              hasStartAdornment,
              hasEndAdornment,
            })}
          >
            {endAdornment}
          </div>
        )}
      </div>

      {error ? (
        <BaseField.Error className={errorClasses({})} match>
          {error}
        </BaseField.Error>
      ) : (
        <BaseField.Error className={errorClasses({})} />
      )}

      {helpText && (
        <BaseField.Description className={helpTextClasses({})}>
          {helpText}
        </BaseField.Description>
      )}
    </BaseField.Root>
  );
};

export default Field;
